module.exports = __webpack_public_path__ + "img/service-four.b38022d0.png";